import React, { useState } from 'react';
import { NavLink, HashRouter } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import PartnerList from './PartnerList';
import { PartnerListProvider, usePartnerListContext } from './PartnerListContext';
import { can } from '../../utils/permissions';

const PartnerPage = ({ setAlert, history }) => {
  const [cModalSelected, setModalSelected] = useState(null);
  const [oPartnerActive, setPartnerActive] = useState(null);

  const { getPartners } = usePartnerListContext();

  const openModal = (cType, oPartner) => {
    setModalSelected(cType);
    setPartnerActive(oPartner);
  };

  const onCloseModal = () => {
    setModalSelected(null);
    setPartnerActive(null);
  };

  const onPartnerDisable = async (oPartner) => {
    try {
      const cMessage = '' // await disablePartner(oPartner.wlpn_nid);
      onCloseModal();
      setAlert('success', cMessage);
      getPartners();
    } catch (oError) {
      onCloseModal();
      setAlert('error', oError.aMsgErrors);
    }
  };

  return (
    <div>
      <div className="title-button">
        <h1>Lista de Parceiros White Label</h1>

        {can('view-wlpartner', 'edit-wlpartner') && (
          <div className="button-stack">
            <HashRouter>
              <NavLink className="btn alternate" to="/Partner/Create" title="Cadastrar parceiro">
                Cadastrar parceiro
              </NavLink>
            </HashRouter>
          </div>
        )}
      </div>

      {cModalSelected === 'partnerDisable' && (
        <PartnerDeactivateModal oPartner={oPartnerActive} onClose={onCloseModal} onSave={onPartnerDisable} />
      )}

      {can('view-wlpartner') && (
        <PartnerList onDeactivate={() => openModal('partnerDisable')} onEdit={(oPartner) => history.push('/Partner/Update/' + oPartner.wlpn_nid)} />
      )}
    </div>
  );
};

const PartnerDeactivateModal = ({ oPartner, onClose = () => {}, onSave = () => {} }) => {
  return (
    <SweetAlert
      danger
      showCancel
      confirmBtnText={'Confirma'}
      cancelBtnText={'Cancelar'}
      cancelBtnBsStyle="danger"
      title={'Desativar parceiro'}
      onConfirm={() => onSave(oPartner)}
      onCancel={onClose}
    >
      <p>Deseja realmente desativar o parceiro: {oPartner.wlpn_cname}</p>
    </SweetAlert>
  );
};

const PartnerIndex = ({ setAlert, ...props }) => {
  return (
    <PartnerListProvider>
      <PartnerPage setAlert={setAlert} {...props} />
    </PartnerListProvider>
  );
};

export default PartnerIndex;
